module.exports = __webpack_public_path__ + "img/AirlineSeatFlatOutlined.878554ba.svg";